// extracted by mini-css-extract-plugin
module.exports = {"userScoreWrapper":"UserScore_userScoreWrapper__1zWB4","userScoreInnerContainer":"UserScore_userScoreInnerContainer__16Dg7"};